import axios from "axios";
import {ActionTree} from "vuex";
import { ClientAttributesState, ClientAttributesItem, ClientAttributesFilter } from "@/store/cdp/client_attributes/types";
import {RootState} from "@/store/types";

export const actions: ActionTree<ClientAttributesState, RootState> = {
    getClientAttributes: ({commit}, data: ClientAttributesFilter) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: '/cdp/v1/client/attributes', params: data})
                .then(resp => {
                    commit('setClientAttributes', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    saveClientAttributes: ({commit, dispatch}, data: ClientAttributesItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: '/cdp/v1/client/attributes/',
                data: data
            })
                .then((resp: any) => {
                    dispatch('getClientAttributes');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getClientAttributesItem: ({commit}, key: string) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/cdp/v1/client/attributes/${key}`})
                .then((resp: any) => {
                    const clientAttributeItem = <ClientAttributesItem>resp.data;
                    commit('setClientAttributeItem', clientAttributeItem);
                    resolve(clientAttributeItem);
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    }
}

